import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { Pressel } from './components/Pressel';
export function App() {
  const [approved, setApproved] = useState<boolean>(() => {
    return sessionStorage.getItem('presselApproved') === 'true';
  });
  const handleApproved = () => {
    sessionStorage.setItem('presselApproved', 'true');
    setApproved(true);
  };
  return <>
      {!approved && <Pressel onApproved={handleApproved} data-id="element-0" />}
      {approved && <LandingPage data-id="element-1" />}
    </>;
}